/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';
import { useTranslation } from '@/i18n/client';
import { observer } from 'mobx-react-lite';

import UKDialog from '@/components/UKDialog';

import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Styles from './index.module.scss';

interface PayRiskModalProps {
  content: string;
  open: boolean;
  onClose: () => void;
  onOk?: null | (() => void);
}
// 支付风险弹窗
const PayRiskModal = observer((props: PayRiskModalProps) => {
  const { t } = useTranslation();

  return (
    <UKDialog
      open={open}
      onClose={props.onClose}
      showCloseBtn={false}
      sx={{
        '& .MuiDialog-paper': {
          width: '380px', // 设置自定义宽度
          maxWidth: 'none', // 取消最大宽度限制
        },
      }}
    >
      <DialogTitle />

      {/* Error info */}
      <DialogContent className={Styles.payError}>{props.content}</DialogContent>

      {/* Button */}
      <DialogActions>
        <Button onClick={props.onClose} className={Styles.button} size='small' variant='outlined'>
          {t('checkout.riskModal.payLater')}
        </Button>
        {props.onOk && (
          <Button onClick={props.onOk} className={Styles.button} size='small' variant='contained'>
            {t('checkout.riskModal.tryOther')}
          </Button>
        )}
      </DialogActions>
    </UKDialog>
  );
});

export default PayRiskModal;
